import { createFormFieldPaymentTypeWatch } from "./form-fields/watchFormFieldPaymentType";
import { createMemberDetailsWatch } from "./details/watchMemberDetails";
import { createMembershipTypeDetailsWatch } from "./details/watchMembershipTypeDetails";
import { createUserDetailsWatch } from "./details/watchUserDetails";
import { createAnswerDetailsWatch } from "./details/watchAnswerDetails";
import { createAnswerAndMembershipTypeWatch } from './details/watchAnswerAndMembershipType';
import { createFormFieldUserEmailWatch } from "./form-fields/watchFormFieldUserEmail";

/**
 * Generates watches for the states data APIs
 * 
 * @param {Object} data 
 * @param {Object} form 
 * @returns {Object}
 */
export function createDataWatches(data, form) {
    return {
        member_details                     : createMemberDetailsWatch(data, form),
        user_details                       : createUserDetailsWatch(data, form),
        membership_type_details            : createMembershipTypeDetailsWatch(data, form),
        answer_details                     : createAnswerDetailsWatch(data, form),
        answer_and_membership_type_details : createAnswerAndMembershipTypeWatch(data, form)
    }
}

/**
 * Generates watches for the states form fields
 * 
 * @param {Object} data 
 * @param {Object} form 
 * @returns {Object}
 */
export function createFormFieldWatches(data, form, progression) {
    return {
        payment_type: createFormFieldPaymentTypeWatch(data, form),
        user_email  : createFormFieldUserEmailWatch(progression, form)
    }
}